import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useToast } from '@veracity/vui'

import { apiKeyClient } from '@/api'
import { useCurrentUser } from '@/hooks'

const BASE_QUERY_KEY = apiKeyClient.QUERY_KEY

export const useHeroApiKey = () => {
  const { showSuccess } = useToast()
  const queryClient = useQueryClient()
  const { currentUser, isAdmin } = useCurrentUser()

  const getApiKeyInfoQuery = useQuery({
    queryKey: BASE_QUERY_KEY,
    queryFn: apiKeyClient.getApiKeyInfo,
    enabled: currentUser?.organization?.hasAccessToApi || isAdmin
  })

  const reactivateHeroApiKeyMutation = useMutation({
    mutationFn: apiKeyClient.reactivateApiKey,
    onSuccess: async () => {
      showSuccess('HERO API key generated')
      await queryClient.invalidateQueries({ queryKey: BASE_QUERY_KEY })
    }
  })

  return {
    heroApiKeyInfo: getApiKeyInfoQuery.data,
    reactivateHeroApiKey: reactivateHeroApiKeyMutation.mutate
  }
}
